import styled, { DefaultTheme } from 'styled-components'

export const ErrorMessage = styled.div`
  color: ${({ theme }: { theme: DefaultTheme }) => theme.color.cinnabar};
`
